const prod = {
  url: {
   API_URL: 'https://ilawapp.com',
   API_URL_USERS: 'https://ilawapp.com'
  }
 };
 const dev = {
  url: {
   API_URL: 'http://localhost/immicompliance_api'
   //API_URL: 'https://ilawapp.com'
  }
 };

 export const config = process.env.NODE_ENV === 'development' ? dev : prod;
